// extracted by mini-css-extract-plugin
export default {"textArea":"MyTextarea_textArea__wGp6t"};